/* eslint-disable */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import api from "api";
import { Form } from "react-bootstrap";
import { handleLoading, useLoading } from "context/LoadingContext";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function EditPeople(props) {
  const [, loadingDispatch] = useLoading();

  const { toggleDialog, getUsers, userData } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const onEditSubmit = async (data) => {
    try {
      handleLoading(loadingDispatch, true);

      await api.patch("users/admin", {
        ...data,
      });
      toggleDialog();
      getUsers();
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    reset({ phoneNumber: userData?.phoneNumber, userId: userData?.userId });
  }, [userData]);

  return (
    <form
      onSubmit={handleSubmit(onEditSubmit)}
      autoComplete="new-password"
      noValidate
    >
      <Form.Group className="mb-3 input input-md" controlId="phoneNumber">
        <Form.Label>رقم الهاتف</Form.Label>
        <Form.Control
          autoComplete="new-password"
          type="text"
          {...register("phoneNumber", {
            required: "الرجاء رقم الهاتف",
            pattern: {
              value: /^078[0-9]*$|^077[0-9]*$|^079[0-9]*$/,
              message: "الرجاء ادخال رقم هاتف صحيح",
            },
            minLength: {
              value: 10,
              message: "يجب أن يحتوي الحقل على 10 ارقام",
            },
            maxLength: {
              value: 10,
              message: "يجب أن يحتوي الحقل على 10 ارقام",
            },
          })}
        />

        {errors.phoneNumber && (
          <Form.Text className="text-danger">
            {errors.phoneNumber.message}
          </Form.Text>
        )}
      </Form.Group>
      <button
        type="submit"
        className="mb-3 btn btn--primary"
        style={{ width: "100%" }}
      >
        موافق
      </button>
    </form>
  );
}

EditPeople.defaultProps = {
  userData: {},
};

EditPeople.propTypes = {
  toggleDialog: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  userData: PropTypes.object,
};

export default EditPeople;
